var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container is-max-desktop has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v("404 Not Found")])])])
}]

export { render, staticRenderFns }